(function($, App, Utils, Components){
  'use strict';

  const logger = new Logger("Header");

  Components.create('Header', {

    Selectors: {
      main: '.js-header',
      preferredStore: '.js-preferred-store'
    },

    bindEvents: function() {

      Components.on(Components.PreferredStore.Events.storeSaved, (e, payload) => {
        let $prefStore = $(Components.Header.Selectors.main).find(Components.Header.Selectors.preferredStore);

        Components.Header.getPreferredStore().then( (html) => {
          $prefStore.removeClass('hidden').html(html);
        }).catch((err) => {
          logger.w(err);
        });

      })

    },

    getPreferredStore: () => {
        return $.ajax({
          url: "/action/getPrefStore",
          type: "POST",
          dataType: "html"
        });
    },


    init: function() {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
